import { Asset } from '@/api/generatedApi';
import { useDownloadAsset } from '@/hooks/useDownloadAsset';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';
import { Download as DownloadIcon } from '@mui/icons-material';
import { Box, Button, IconButton, IconButtonProps, Tooltip } from '@mui/material';

export const DownloadAssetButton = ({
  asset,
  className,
  variant = 'button',
  size = 'small',
}: {
  asset: Asset;
  className?: string;
  variant?: 'button' | 'icon';
  size?: IconButtonProps['size'];
}) => {
  const { downloadAsset } = useDownloadAsset();

  const handleDownload = async () => {
    await downloadAsset(asset);
  };

  return variant === 'icon' ? (
    <Tooltip title='Download'>
      <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <IconButton
          size={size}
          onClick={() => void handleDownload()}
          data-testid={AssetPageObjectModel.DownloadAssetButton}
        >
          <DownloadIcon />
        </IconButton>
      </Box>
    </Tooltip>
  ) : (
    <Button
      onClick={() => void handleDownload()}
      startIcon={<DownloadIcon />}
      size={size}
      className={className}
      data-testid={AssetPageObjectModel.DownloadAssetButton}
    >
      Download
    </Button>
  );
};
